angular.module('logbook')
    .config(['formlyConfigProvider', function(formlyConfigProvider) {
        var unique = 1;

        formlyConfigProvider.extras.fieldTransform = formlyConfigProvider.extras.fieldTransform || [];
        formlyConfigProvider.extras.fieldTransform.push(clearOnHideTransformer);

        function clearOnHideTransformer(fields) {
            return fields.map(function(field) {
                field.data = field.data || {};
                if (field.key && !field.noFormControl && field.hideExpression && !field.data.dontClearOnHide) {
                    addFieldClearOnHideWatcher(field);
                }
                return field;
            });
        }

        function addFieldClearOnHideWatcher(field) {
            var watcher = getWatcher();
            if (field.watcher) {
                if (!angular.isArray(field.watcher)) {
                    field.watcher = [field.watcher];
                }
                field.watcher.push(watcher);
            } else {
                field.watcher = watcher;
            }
        }

        function getWatcher() {
            return {
                expression: function(field) {
                    return field.hide;
                },
                listener: function(field, newHide, oldHide, scope) { // If a field is hidden, reset it to its default value.
                    if (field.hide) scope.model[field.key] = field.defaultValue;
                }
            };
        }

        formlyConfigProvider.setWrapper({
            name: 'hasError',
            template: `
                <div class="form-group" ng-class="{'has-error': showError}">
                    <label class="control-label" for="{{id}}">{{to.label}}</label>
                    <formly-transclude></formly-transclude>
                    <div ng-messages="fc.$error" ng-if="showError" class="text-danger">
                    <div ng-message="{{ ::name }}" ng-repeat="(name, message) in ::options.validation.messages" class="message">{{message(name)}}</div>
                    </div>
                </div>
            `
        })

        formlyConfigProvider.setType({
            name: 'dataImage',
			template: require('../../shared/formly/data-image.html'),
            controller: ['$scope', 'FileUploader', function($scope, FileUploader) {
                $scope.uploader = new FileUploader({
                    autoUpload: false
                });
                $scope.clearImage = function() {
                    delete $scope.model[$scope.options.key];
                    $scope.form.$setDirty();
                };
                $scope.uploader.onAfterAddingFile = function(fileItem) {
                    var reader = new FileReader();

                    function onLoadFile(event) {
                        $scope.model[$scope.options.key] = event.target.result;
                        $scope.$digest();
                    }

                    reader.onload = onLoadFile;
                    reader.readAsDataURL(fileItem._file);
                    $scope.form.$setDirty();
                };
            }]
        });

        formlyConfigProvider.setType({
            name: '24HrTime',
            extends: 'input',
            defaultOptions: {
                parsers: [function(val) {
                    return val + "Z" + new Date().getTimezoneOffset();
                }],
                formatters: [function(val) {
                    return val.substring(0, 4);
                }]
            }
        });

        formlyConfigProvider.setType({
            name: 'input',
            wrapper: ['hasError'],
            template: `<input class="form-control" ng-model="model[options.key]">`
        });

        formlyConfigProvider.setType({
            name: 'repeatSection',
			template: require('../../shared/formly/repeat-section.html'),
            controller: ['$scope', function($scope) {
                $scope.copyFields = function(fields) {
                    fields = angular.copy(fields);
                    addRandomIds(fields);
                    return fields;
                };

                $scope.generateTempFields = function(fields) {
                    var tempFields = $scope.copyFields(fields);
                    removeRequired(tempFields);
                    return tempFields;
                };

                $scope.addNew =  function (element) {
                    $scope.model[$scope.options.key] = $scope.model[$scope.options.key] || [];
                    var repeatsection = $scope.model[$scope.options.key];
                    repeatsection.push(element);
                };

                $scope.setTempElement = function() { $scope.tempModel = {}; };

                /** Assumes strings and default value of empty string.
                 * Will have to be adjusted to support different input types. */
                $scope.tempModelValid = function() {
                    var isValid = true;
                    if (!$scope.tempModel || Object.keys($scope.tempModel).length == 0) return false;
                    Object.keys($scope.tempModel).forEach(function(prop) {
                        if ($scope.tempModel[prop] === "") isValid = false;
                    });
                    return isValid;
                };

                function addRandomIds(fields) {
                    unique++;
                    angular.forEach(fields, function(field, index) {
                        if (field.fieldGroup) {
                            addRandomIds(field.fieldGroup);
                            return; // fieldGroups don't need an ID
                        }

                        if (field.templateOptions && field.templateOptions.fields) {
                            addRandomIds(field.templateOptions.fields);
                        }

                        field.id = field.id || (field.key + '_' + index + '_' + unique + getRandomInt(0, 9999));
                    });
                }

                function removeRequired(fields) {
                    angular.forEach(fields, function(field) {
                        if (field.fieldGroup) removeRequired(field.fieldGroup);

                        if (field.templateOptions) {
                            field.templateOptions.required = false;
                            if (field.templateOptions.fields) removeRequired(field.templateOptions.fields);
                        }
                    });
                }

                function getRandomInt(min, max) {
                    return Math.floor(Math.random() * (max - min)) + min;
                }
            }]
        })}]);